import * as React from 'react';
import { useEffect } from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';
import apiService from '../services/ApiService';

export default function TutorialModal({ open, setOpen, setTutorialEnabled }) {

    const handleClose = () => {
        setOpen(false);
    }

    // Light-dismiss : Escape ferme la modal
    useEffect(() => {
        if (!open) return;
        const onKeyDown = (e: KeyboardEvent) => { if (e.key === 'Escape') handleClose(); };
        document.addEventListener('keydown', onKeyDown);
        return () => document.removeEventListener('keydown', onKeyDown);
    }, [open]);

    return (
        <Transition appear show={!!open} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={handleClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/25" onClick={handleClose} />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-[60%] min-w-[400px] min-h-[250px] transform overflow-hidden rounded-lg bg-white p-6 text-left align-middle shadow-xl transition-all">
                                <h2 className="text-center text-[22px] font-bold mt-2 flex items-center justify-center gap-1">
                                    Tutorial
                                    <span className="material-symbols-outlined text-[24px]">menu_book</span>
                                </h2>

                                <h4 className="text-center text-base font-bold mt-4">
                                    Welcome to Peerception !
                                </h4>

                                <p className="text-center text-base mt-6">
                                    We're excited to guide you through the features and functionalities of our platform.
                                    <br/>
                                    This tutorial will help you get started and make the most out of your experience.
                                </p>

                                <p className="text-center text-base mt-6">
                                    Ready to begin ?
                                </p>

                                <div className="flex justify-center gap-8 mt-6">
                                    <button
                                        className="h-10 w-[140px] rounded-lg bg-white border border-slate-300 text-slate-400 hover:bg-black/5 transition-colors"
                                        onClick={() => {
                                            apiService.disableTutorial().then(async(response) => {
                                                if (response) {
                                                    setTutorialEnabled(false);
                                                    handleClose();
                                                }
                                            })
                                        }}
                                    >
                                        Skip
                                    </button>

                                    <button
                                        className="h-10 w-[140px] rounded-lg bg-black text-slate-300 hover:bg-white/15 transition-colors flex items-center justify-center gap-1"
                                        onClick={() => {
                                            setTutorialEnabled(true);
                                            handleClose();
                                        }}
                                    >
                                        <span className="ml-1">Let's Go</span>
                                        <span className="material-symbols-outlined text-[20px] text-white">done</span>
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )

}
